import { render, staticRenderFns } from "./ClientMinimum.vue?vue&type=template&id=7ba20ee2"
import script from "./ClientMinimum.vue?vue&type=script&lang=js"
export * from "./ClientMinimum.vue?vue&type=script&lang=js"
import style0 from "./ClientMinimum.vue?vue&type=style&index=0&id=7ba20ee2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports